module.exports = __webpack_public_path__ + "static/media/0017.45391e87.jpg";